export class TableRowValue {

  constructor(public value, public template: any, public translate?: boolean) {}

}
